import  { memo } from "react"
import type { FC } from "react"

const CheckSolidIconComponent: FC = () => {
  return (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 14.2207C11.0899 14.2207 14 11.3106 14 7.7207C14 4.13085 11.0899 1.2207 7.5 1.2207C3.91015 1.2207 1 4.13085 1 7.7207C1 11.3106 3.91015 14.2207 7.5 14.2207ZM10.5596 6.88032C10.8135 6.62648 10.8135 6.21492 10.5596 5.96108C10.3058 5.70724 9.89422 5.70724 9.64038 5.96108L6.85 8.75146L5.35962 7.26108C5.10578 7.00724 4.69422 7.00724 4.44038 7.26108C4.18654 7.51492 4.18654 7.92648 4.44038 8.18032L6.39038 10.1303C6.64422 10.3842 7.05578 10.3842 7.30962 10.1303L10.5596 6.88032Z"
        fill="#00AB30"
      />
    </svg>
  )
}

export const CheckSolidIcon = memo(CheckSolidIconComponent)
